import { get, find } from "lodash";
import { useBookUnits } from "store/booksUnits/selectors";
import { useResources } from "store/resources/selectors";
import { useStory } from "store/story/selectors";
import { BACK_TO_BOOK } from "utils/config/reference";
import {
  generateUrlForNonEbook,
  getStoryUrl,
  isVideo,
} from "utils/lib/ebookHelper";

const useGetRedirectUrlForNotification = () => {
  const bookUnits = useBookUnits();
  const resources = useResources();
  const story = useStory();

  const generateUrl = (CHAPTER_ID, page, activity, quiz) => {
    const storyUrl = getStoryUrl(story, CHAPTER_ID, page, quiz, activity);
    const backToLabel = BACK_TO_BOOK[CHAPTER_ID];
    const BALCON_PAGES = get(
      find(bookUnits, ["bookId", CHAPTER_ID]),
      "pages",
      []
    );
    const bookitem = find(
      BALCON_PAGES,
      (k) => parseInt(k.start) <= page && parseInt(k.finish) >= page
    );
    const url = generateUrlForNonEbook(
      bookitem?.id,
      page,
      activity,
      quiz,
      backToLabel,
      null,
      CHAPTER_ID
    );
    if (url && backToLabel) {
      return url;
    } else if (storyUrl) {
      return storyUrl;
    } else {
      return null;
    }
  };

  const redirectToAssignmentVideo = (id, quizId) => {
    let url = `/video?id=${id}&quiz=null`;
    return url;
  };

  // Require two parameter chapter and pageId for ebook
  const redirectToBook = (data, type = '') => {
    let url = "";
    const chapter = data?.chapter;
    const assignmentPage = data?.page;
    const isGameType = data?.assignmentType;
  
    // Priority condition
    if (['debate', 'game', 'bingo', 'worksheet'].includes(isGameType) && type === 'update_grade') {
      url = `/student/class?view=studentData`;
    } 
    // Resource page redirect
    else if (isVideo(chapter, resources)) {
      url = redirectToAssignmentVideo(chapter, get(data, "data.id"));
    } 
    // Non assignable ebook's URL
    else if (generateUrl(chapter, assignmentPage, null, null)) {
      url = generateUrl(chapter, assignmentPage, null, null);
    } 
    // Default assignable ebook's URL
    else {
      url = `/ebook?chapter=${chapter}&page=${assignmentPage}&activity=null&quiz=null`;
    }
  
    return url;
  };
  

  return { redirectToBook };
};


export default useGetRedirectUrlForNotification;